import { Component, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { AdminAppbarComponent } from '../layout/components/admin-appbar/admin-appbar.component';
import { SVGIcon, plusIcon } from '@progress/kendo-svg-icons';
import { BaseComponent } from '../../../core/shared/common/base.component';
import { DatatableComponent } from '../../../core/components/datatable/datatable.component';
import { SocAdvisory } from '../../../core/models/entities';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import DataTable from 'datatables.net-dt';

@Component({
  selector: 'app-advisories',
  standalone: true,
  imports: [CommonModule, AdminAppbarComponent, ButtonModule, DropDownListModule, DatatableComponent],
  templateUrl: './advisories.page.html',
  styleUrl: './advisories.page.scss',
})
export class AdvisoriesPage extends BaseComponent {
  @ViewChild(DatatableComponent) private table?: DatatableComponent;

  public plusIcon: SVGIcon = plusIcon;
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  advisoryForm: any;
  socAdivsoryService: any;

  public datatableUrl = `${environment.apiUrl}/v1/advisory/administrative/advisory/`;

  public publishedOptions = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ];

  private publishedFilter: boolean | null = null;

  public initialFilters = this.buildFilters();

  public datatableColumns = [
    { data: 'title', name: 'title', title: 'Title', type: 'string', render: DataTable.render.text() },
    { data: 'author', name: 'author', title: 'Author', type: 'string', render: DataTable.render.text() },
    {
      data: 'is_published',
      name: 'is_published',
      title: 'Published',
      type: 'boolean',
      render: (data: boolean) => (data ? 'Yes' : 'No'),
    },
    { data: 'created_at', name: 'created_at', title: 'Date Created', type: 'string', render: DataTable.render.text() },
  ];

  private buildFilters(): Record<string, string> {
    const filters: Record<string, string> = { $orderby: 'created_at desc' };
    if (this.publishedFilter != null) {
      filters['$filter'] = `is_published eq ${this.publishedFilter}`;
    }
    return filters;
  }

  public publishedChange($event: { text: string; value: boolean | null }): void {
    this.publishedFilter = $event?.value ?? null;
    this.table?.setFilters(this.buildFilters());
  }

  public addAdvisory() {
    this.router.navigate(['new-advisory'], { relativeTo: this.route });
  }

  public editAdvisory(row: unknown) {
    const advisory = row as SocAdvisory;
    this.router.navigate(['/admin/advisories/new-advisory'], { queryParams: { id: advisory.pk } });
  }

  public clear() {
    this.advisoryForm.reset();
  }

  delete($event: Event) {
    $event.preventDefault();
    const id = this.advisoryForm.value.pk!;
    this.socAdivsoryService
      .deleteSocAdvisoryItem(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.clear();
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }
}
